import {useEffect,useRef,useState} from 'react';
import {callCallableNativeSafe} from '../utils/callableNativeSafe';
import {Capacitor} from '@capacitor/core';
import {App} from '@capacitor/app';

export default function useSessionPrograms(businessId,customerId,enabled=true){
 const identity=enabled && businessId && customerId ? `${businessId}/${customerId}` : '';
 const [state,setState]=useState({identity:'',programs:[],loading:false,error:''});
 const reload=useRef(()=>{});
 useEffect(()=>{
  let active=true,busy=false,loaded=false,lastStarted=0,pending=false;
  if(!identity){setState({identity,programs:[],loading:false,error:''});reload.current=()=>{};return;}
  const refresh=async(force=false)=>{
   if(!active)return;
   if(busy){if(force)pending=true;return;}
   if(!force && (document.visibilityState==='hidden'||Date.now()-lastStarted<1000))return;
   busy=true;lastStarted=Date.now();
   setState(s=>({...s,identity,programs:s.identity===identity?s.programs:[],loading:!loaded,refreshing:loaded}));
   try{
    const r=await callCallableNativeSafe({functionName:'getCustomerSessionPrograms',data:{businessId,customerId},timeoutMs:15000});
    if(active){loaded=true;setState({identity,programs:(r.data||r).programs||[],loading:false,refreshing:false,error:'',refreshError:''});}
   }catch(e){if(active){
    if(['permission-denied','unauthenticated'].includes(String(e.code||'').replace('functions/',''))){loaded=false;setState({identity,programs:[],loading:false,refreshing:false,error:'Tu acceso cambió. Vuelve a iniciar sesión o consulta al administrador.'});}
    else setState(s=>({...s,loading:false,refreshing:false,...(loaded?{refreshError:'No pudimos actualizar. Comprueba tu conexión antes de registrar cambios.'}:{error:'No pudimos consultar los programas del cliente.'})}));
   }}
   finally{busy=false;if(pending&&active){pending=false;refresh(true);}}
  };
  const resume=()=>refresh();
  const offline=()=>setState(s=>({...s,refreshError:'Sin conexión. Conservamos los datos; vuelve a conectarte antes de registrar cambios.'}));
  reload.current=()=>refresh(true);
  refresh(true);
  window.addEventListener('focus',resume);
  window.addEventListener('online',resume);
  window.addEventListener('offline',offline);
  window.addEventListener('pageshow',resume);
  document.addEventListener('visibilitychange',resume);
  const timer=setInterval(resume,30000);
  let nativeListener;
  if(Capacitor.isNativePlatform()){
   Promise.resolve(App.addListener('appStateChange',({isActive})=>{if(isActive)refresh(true);})).then(listener=>{if(active)nativeListener=listener;else listener.remove();}).catch(()=>{});
  }
  return ()=>{active=false;clearInterval(timer);nativeListener?.remove();window.removeEventListener('focus',resume);window.removeEventListener('online',resume);window.removeEventListener('offline',offline);window.removeEventListener('pageshow',resume);document.removeEventListener('visibilitychange',resume);};
 },[identity,businessId,customerId]);
 return {...(state.identity===identity?state:{programs:[],loading:!!identity,error:''}),retry:()=>reload.current()};
}
